const pharmacySwitch = {
  change: 'Möchten Sie Ihre Apotheke wechseln?',
  cartSubtitle: 'Preise, Verfügbarkeiten und Services können je nach Apotheke variieren.',
  cartWarning: 'Aus Datenschutzgründen werden die Produkte in Ihrem Warenkorb gelöscht, wenn Sie die Apotheke wechseln.',
  cartWithCouponWarning: 'Aus Datenschutzgründen werden die Produkte und der hinterlegte Coupon in Ihrem Warenkorb gelöscht, wenn Sie die Apotheke wechseln.',
  yourPharmacy: 'Ihre ausgewählte Apotheke',
  newPharmacy: 'Neu gewählte Apotheke',
  homePharmacy: 'Stammapotheke',
  currentlySelectedPharmacy: 'Aktuell ausgewählte Apotheke',
  maintain: 'Apotheke beibehalten',
  selectNew: 'Neue Apotheke auswählen',
  selectHome: 'Zur Stammapotheke wechseln',
}

export default pharmacySwitch
